import { Button, Select } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import AppRangePicker from '@/components/common/AppRangePicker';
import PermissionGate from '@/components/auth/PermissionGate';
import { PERMISSIONS } from '@/config/permissions';

export default function ReportingScopeToolbar({
  dateRange,
  onDateRangeChange,
  scopeUserId,
  onScopeChange,
  scopeOptions,
  optionsLoading,
  downloadingDealSheet = false,
  onDownloadDealSheet,
}) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
      <AppRangePicker
        value={dateRange}
        onChange={onDateRangeChange}
        allowClear={false}
        format="DD MMM YYYY"
      />
      <Select
        className="min-w-[220px]"
        value={scopeUserId}
        loading={optionsLoading}
        onChange={onScopeChange}
        options={scopeOptions.map((opt) => ({
          value: opt.id,
          label: opt.label,
        }))}
      />
      <PermissionGate permission={PERMISSIONS.INVESTORS_MANUAL_DEAL_SHEET_GENERATE}>
        <Button
          type="primary"
          icon={<DownloadOutlined />}
          loading={downloadingDealSheet}
          disabled={downloadingDealSheet || !dateRange?.[0] || !dateRange?.[1]}
          onClick={onDownloadDealSheet}
        >
          Download Deal Sheet
        </Button>
      </PermissionGate>
    </div>
  );
}
